// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollButton_button__3-fx-","visible":"ScrollButton_visible__Gupj6"};